import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';


export const PTL_BULK_MIS = createRequestTypes('PTL_BULK_MIS');
export const PTL_BULK_MIS_GET_TRANSPORTERS = createRequestTypes('PTL_BULK_MIS_GET_TRANSPORTERS');

export const postPTLBulkMIS = {
  request: (payload, tpt) => createAction(PTL_BULK_MIS[REQUEST], { payload, tpt }),
  success: (response) => createAction(PTL_BULK_MIS[SUCCESS], { response }),
  failure: (response) => createAction(PTL_BULK_MIS[FAILURE], { response }),
};

export const getPTLBulkMISTransporters = {
  request: () => createAction(PTL_BULK_MIS_GET_TRANSPORTERS[REQUEST]),
  success: (response) => createAction(PTL_BULK_MIS_GET_TRANSPORTERS[SUCCESS], { response }),
  failure: (response) => createAction(PTL_BULK_MIS_GET_TRANSPORTERS[FAILURE], { response }),
};
